export function Spinner({ label = "loading" }: { label?: string }) {
  return (
    <p className="load-note">
      {label}
      <span className="spinner" aria-hidden="true">
        …
      </span>
    </p>
  );
}

export function LoadError({ label = "couldn't reach the desk — showing my notes anyway" }: { label?: string }) {
  return <p className="load-note error">{label}</p>;
}
